// Texts of the console shell (src/app): routes, header, side menu, summary
// strip, login, error boundaries. Glossary: docs/design/i18n.md.

import { defineMessages } from '@/shared/i18n'

export const appMessages = defineMessages({
  ru: {
    appTitle: 'airgate — пульт MCR',
    bootFailed: 'Пульт не запустился: {error}. Обновите страницу.',

    routeLogin: 'Вход',
    routeNotFound: 'Страница не найдена',
    routeForbidden: 'Доступ ограничен',
    routeStyleguide: 'Компоненты',

    // AppShell
    offlineBanner:
      'Нет связи с сервером пульта. Состояние на экране может быть устаревшим — эфир при этом продолжается, агент работает сам.',

    // StatusStrip
    controlOnline: 'Сервер на связи',
    controlConnecting: 'Подключение к серверу',
    controlOffline: 'Нет связи с сервером',
    controlRetry: 'Нет связи, повтор через {delay}',
    controlUnauthorized: 'Сессия не принята',
    controlForbidden: 'Сервер отказал: недостаточно прав',
    controlIdle: 'Не подключено',
    siteNoData: 'нет данных',
    siteAgentOffline: 'агент не на связи',
    siteStale: 'статус устарел',
    siteClockUnsynced: 'часы не синхронизированы',
    siteAgentOnline: 'агент на связи',
    sitesLabel: 'Площадки',
    alarmsAria: 'Активные алармы, независимо от подтверждения',
    alarmsCritical: 'Аварий сейчас: {count}',
    alarmsCriticalWord: 'Аварий сейчас:',
    alarmsCriticalTitle: 'Аварии, которые горят сейчас, включая уже подтверждённые',
    alarmsWarning: 'Предупреждений: {count}',
    alarmsWarningWord: 'Предупреждений:',
    alarmsWarningTitle: 'Предупреждения, которые горят сейчас, включая уже подтверждённые',
    alarmsNoData: 'Алармы: нет данных',

    // StationClock
    clockLabel: 'Текущее время',

    // SideNav
    navLabel: 'Разделы пульта',
    navUnacked: 'Неподтверждённых алармов: {count}',
    logout: 'Выйти',
    navDestinations: 'Куда шлём',
    navAdvancedGroup: 'Расширенное',
    navMore: 'Ещё',
    navBottomLabel: 'Основные разделы',
    navMoreClose: 'Закрыть',
    navGroupAir: 'Эфир',
    navGroupRestream: 'Рестрим',
    navGroupSetup: 'Настройка',
    navGroupSystem: 'Система',
    navAdvanced: 'Расширенный вид',
    navAdvancedTitle:
      'Показать в меню инженерные экраны: линии, подачи, временные входы, пресеты видео, площадки, профили выхода, журнал, все схемы каналов. Выбор запоминается в этом браузере.',

    // Keyboard shortcuts (HotkeysLayer.vue, ux-simplify Б13)
    hkTitle: 'Горячие клавиши',
    hkGoHome: 'Главный экран',
    hkGoWall: 'Стена',
    hkGoAlarms: 'Алармы',
    hkGoRestream: 'Рестрим',
    hkGoOutputs: 'Выходы',
    hkSearch: 'Поиск на экране (где он есть)',
    hkCreate: 'Создать…',
    hkHelp: 'Эта подсказка',
    hkNote: 'Клавиши не срабатывают, пока курсор в поле ввода. Опасных действий на клавишах нет.',
    hkClose: 'Закрыть',
    createTitle: 'Создать',
    createRestream: 'Рестрим по ссылке',
    createRestreamHint: 'YouTube, VK, HLS → стенограм, Flussonic, площадки',
    createSimple: 'Новый канал',
    createSimpleHint: 'Вход, заставка и назначение одной формой',
    createIngest: 'Адрес для корреспондента',
    createIngestHint: 'Временный вход: готовый адрес srt:// для отправителя',
    createTarget: 'Назначение (цель)',
    createTargetHint: 'Flussonic, стенограм или RTMP-площадка',
    createChannel: 'Канал (полная форма)',
    createChannelHint: 'Все настройки канала сразу',
    createNone: 'Создавать объекты может инженер или администратор.',

    // Error boundaries
    crashTitle: 'Экран не удалось показать',
    retry: 'Попробовать снова',
    summaryCrashed: 'Сводка недоступна.',

    // NotFound / auth callback
    notFoundTitle: 'Такой страницы в пульте нет',
    notFoundText: 'Возможно, ссылка устарела или объект удалён.',
    notFoundLink: 'Открыть стену',
    forbiddenTitle: 'Нет доступа к этому разделу',
    forbiddenText: 'Ваша роль не даёт прав на этот экран. Если это неверно, обратитесь к администратору пульта.',
    forbiddenLink: 'На главную',
    callbackText: 'Завершаем вход…',

    // Session store
    loginNoRole: 'У учётной записи нет роли для работы с пультом.',
    loginTokenInvalid: 'Токен недействителен или истёк.',
    loginControlDown: 'Сервер пульта недоступен. Пульт подключится сам, как только сервер ответит.',
    loginNotConfiguredOidc: 'Вход не настроен: в config.json не задан OIDC-провайдер.',
    loginProviderDown: 'Провайдер входа недоступен: {error}',
    loginStartFailed: 'Не удалось начать вход.',
    loginNotConfigured: 'Вход не настроен.',
    loginFailedDetail: 'Вход не выполнен: {error}',
    loginFailed: 'Вход не выполнен.',

    // LoginView
    loginTitle: 'Пульт airgate',
    loginLead: 'Вход через корпоративную учётную запись. Роль определяет, что можно менять: наблюдатель только смотрит.',
    loginLeadToken: 'Вход по токену доступа. Роль определяет, что можно менять: наблюдатель только смотрит.',
    loginNoProviderToken: 'Вход через корпоративную учётную запись не настроен — войдите по токену доступа.',
    loginKeycloak: 'Войти через Keycloak',
    loginNoProviderBefore: 'Провайдер входа не настроен. Укажите',
    loginNoProviderAnd: 'и',
    loginNoProviderIn: 'в',
    loginNoProviderAfter: 'рядом с пультом.',
    standWarning: 'Тестовый стенд: вход без корпоративной учётной записи.',
    standUser: 'Пользователь стенда',
    standLogin: 'Войти на стенд',
    tokenLabel: 'Токен доступа',
    tokenPlaceholder: 'Вставьте токен доступа',
    tokenLogin: 'Войти с токеном',
    standNetwork: 'Не удалось связаться со стендом за токеном: проверьте сеть.',
    standUnauthorized: 'Стенд отклонил запрос токена (не пройдена базовая авторизация).',
    standHttp: 'Стенд не выдал токен (HTTP {status}).',
    standEmpty: 'Стенд вернул пустой токен.',

    // Summary strip (summary.ts + SummaryStrip.vue)
    summaryLabel: 'Сводка',
    summaryStreams: 'Потоки: идут {on} из {total}',
    summaryStreamsError: '· ошибка {n}',
    summaryStreamsTitle: 'Потоки консоли и Flussonic выбранных площадок',
    summaryStreamsUnknownTitle: 'Потоки консоли и Flussonic выбранных площадок. У {n} состояние неизвестно: пульт не видит их источника.',
    summaryIn: 'Вход',
    summaryOut: 'Выход',
    summarySites: 'Площадки: {on} из {total} на связи',
    siteFilterLabel: 'Площадка',
    siteFilterAll: 'Все площадки',
    summaryProblemsBasic: 'Проблем: {count}',
    summaryConfigError: 'нет данных о конфигурации — повтор через 10 с',
    summaryAwaiting: 'ждём статус агента…',
    summaryLegs: 'Назначения: в эфире {on} из {total}',
    summaryLegsTitle:
      'Подключено назначений из всех заведённых на площадке, включая назначения остановленных подач. «Обзор» считает только те, что должны быть в эфире.',
    summaryLossTitle:
      'Накопительно с подключения: ретрансмиссий вход {inRetrans} / выход {outRetrans}, дроп вход {inDrop} / выход {outDrop}',
    summaryLoss: 'Потери SRT: вход {inLoss} / выход {outLoss}',
    summaryLost: 'Не восстановлено: вход {inLost} / выход {outLost}',
    summaryLostTitle:
      'Два аларма SRT. «Линк болеет» — обнаруженные потери (пакеты не пришли с первого раза) выше 2 % за 10 с: предупреждение, повтор обычно всё восстанавливает. «Потери в эфире» — невосстановленные выше 0,1 % за 10 с: дыры в картинке, критично. Пороги по умолчанию; свои — в «Настройках алармов».',
    summaryStaleSince: 'нет данных с {time}',

    // StyleguideView (development only)
    sgSpeech: 'Речь',
    sgMusic: 'Музыка',
    sgHot: 'Перегруз',
    sgSilence: 'Тишина',
    sgDead: 'Данные пропали',
    sgCriticalUnacked: 'Авария, не подтверждена',
    sgWarningUnacked: 'Внимание, не подтверждено',
    sgOnAir: 'В эфире',
    sgRunning: 'Работает',
    sgHlsUrl: 'Адрес HLS для проверки плеера',
    sgTable: 'Таблица',
    sgChannel: 'Канал',
    sgState: 'Состояние',
    sgBitrate: 'Битрейт, Мбит/с',
    sgLoss: 'Потери, %',
    sgRow1: 'UN TV, зал Генассамблеи',
    sgRow3: 'Москва, резерв',
    sgDegraded: 'С отклонением',
    sgNoSignal: 'Нет сигнала',
  },
  en: {
    appTitle: 'airgate — MCR console',
    bootFailed: 'The console failed to start: {error}. Reload the page.',

    routeLogin: 'Log in',
    routeNotFound: 'Page not found',
    routeForbidden: 'Access restricted',
    routeStyleguide: 'Components',

    offlineBanner:
      'No connection to the console server. What you see may be out of date — air is not affected, the agent keeps running on its own.',

    controlOnline: 'Server online',
    controlConnecting: 'Connecting to the server',
    controlOffline: 'No connection to the server',
    controlRetry: 'No connection, retrying in {delay}',
    controlUnauthorized: 'Session rejected',
    controlForbidden: 'Server refused: insufficient permissions',
    controlIdle: 'Not connected',
    siteNoData: 'no data',
    siteAgentOffline: 'agent offline',
    siteStale: 'status stale',
    siteClockUnsynced: 'clock not synchronised',
    siteAgentOnline: 'agent online',
    sitesLabel: 'Sites',
    alarmsAria: 'Active alarms, acknowledged or not',
    alarmsCritical: 'Critical now: {count}',
    alarmsCriticalWord: 'Critical now:',
    alarmsCriticalTitle: 'Critical alarms firing now, including acknowledged ones',
    alarmsWarning: 'Warnings: {count}',
    alarmsWarningWord: 'Warnings:',
    alarmsWarningTitle: 'Warnings firing now, including acknowledged ones',
    alarmsNoData: 'Alarms: no data',

    clockLabel: 'Current time',

    navLabel: 'Console sections',
    navUnacked: 'Unacknowledged alarms: {count}',
    logout: 'Log out',
    navDestinations: 'Destinations',
    navAdvancedGroup: 'Advanced',
    navMore: 'More',
    navBottomLabel: 'Main sections',
    navMoreClose: 'Close',
    navGroupAir: 'On air',
    navGroupRestream: 'Restream',
    navGroupSetup: 'Setup',
    navGroupSystem: 'System',
    navAdvanced: 'Advanced view',
    navAdvancedTitle:
      'Show the engineering screens in the menu too: lines, routes, temporary inputs, video presets, sites, egress profiles, the journal, all channel schemes. The choice is remembered in this browser.',

    hkTitle: 'Keyboard shortcuts',
    hkGoHome: 'Home screen',
    hkGoWall: 'Wall',
    hkGoAlarms: 'Alarms',
    hkGoRestream: 'Restream',
    hkGoOutputs: 'Outputs',
    hkSearch: 'Search on the screen (where there is one)',
    hkCreate: 'Create…',
    hkHelp: 'This sheet',
    hkNote: 'Keys do nothing while the cursor is in an input field. No dangerous action is on a key.',
    hkClose: 'Close',
    createTitle: 'Create',
    createRestream: 'Restream from a link',
    createRestreamHint: 'YouTube, VK, HLS → stenogram, Flussonic, platforms',
    createSimple: 'New channel',
    createSimpleHint: 'Input, slate and destination in one form',
    createIngest: 'Address for a contributor',
    createIngestHint: 'A temporary input: a ready srt:// address for the sender',
    createTarget: 'Destination (target)',
    createTargetHint: 'Flussonic, stenogram or an RTMP platform',
    createChannel: 'Channel (full form)',
    createChannelHint: 'Every channel setting at once',
    createNone: 'Objects are created by an engineer or an administrator.',

    crashTitle: 'This screen could not be shown',
    retry: 'Try again',
    summaryCrashed: 'Summary unavailable.',

    notFoundTitle: 'There is no such page in the console',
    notFoundText: 'The link may be outdated or the object deleted.',
    notFoundLink: 'Open the wall',
    forbiddenTitle: 'No access to this section',
    forbiddenText: 'Your role does not have permission for this screen. If this looks wrong, ask the console administrator.',
    forbiddenLink: 'Go home',
    callbackText: 'Finishing login…',

    loginNoRole: 'This account has no role for the console.',
    loginTokenInvalid: 'The token is invalid or has expired.',
    loginControlDown: 'The console server is unreachable. The console will connect by itself as soon as the server answers.',
    loginNotConfiguredOidc: 'Login is not configured: config.json has no OIDC provider.',
    loginProviderDown: 'Login provider unavailable: {error}',
    loginStartFailed: 'Could not start the login.',
    loginNotConfigured: 'Login is not configured.',
    loginFailedDetail: 'Login failed: {error}',
    loginFailed: 'Login failed.',

    loginTitle: 'airgate console',
    loginLead: 'Log in with your corporate account. Your role decides what you can change: a viewer can only watch.',
    loginLeadToken: 'Log in with an access token. Your role decides what you can change: a viewer can only watch.',
    loginNoProviderToken: 'Corporate account login is not set up — log in with an access token.',
    loginKeycloak: 'Log in with Keycloak',
    loginNoProviderBefore: 'No login provider is configured. Set',
    loginNoProviderAnd: 'and',
    loginNoProviderIn: 'in',
    loginNoProviderAfter: 'next to the console.',
    standWarning: 'Test stand: login without a corporate account.',
    standUser: 'Stand user',
    standLogin: 'Log in to the stand',
    tokenLabel: 'Access token',
    tokenPlaceholder: 'Paste the access token',
    tokenLogin: 'Log in with token',
    standNetwork: 'Could not reach the stand for a token: check the network.',
    standUnauthorized: 'The stand refused the token request (basic authentication failed).',
    standHttp: 'The stand did not issue a token (HTTP {status}).',
    standEmpty: 'The stand returned an empty token.',

    summaryLabel: 'Summary',
    summaryStreams: 'Streams: {on} of {total} running',
    summaryStreamsError: '· {n} in error',
    summaryStreamsTitle: 'Streams of the console and Flussonic on the chosen sites',
    summaryStreamsUnknownTitle: 'Streams of the console and Flussonic on the chosen sites. {n} have an unknown state: the console cannot see their source.',
    summaryIn: 'In',
    summaryOut: 'Out',
    summarySites: 'Sites: {on} of {total} online',
    siteFilterLabel: 'Site',
    siteFilterAll: 'All sites',
    summaryProblemsBasic: 'Problems: {count}',
    summaryConfigError: 'no configuration data — retrying in 10 s',
    summaryAwaiting: 'waiting for agent status…',
    summaryLegs: 'Destinations: {on} of {total} on air',
    summaryLegsTitle:
      'Destinations connected out of every destination set up at the site, those of stopped routes included. “Overview” counts only the ones that should be on air.',
    summaryLossTitle:
      'Cumulative since connect: retransmits in {inRetrans} / out {outRetrans}, drops in {inDrop} / out {outDrop}',
    summaryLoss: 'SRT loss: in {inLoss} / out {outLoss}',
    summaryLost: 'Unrecovered: in {inLost} / out {outLost}',
    summaryLostTitle:
      'Two SRT alarms. “Link is sick”: detected loss (packets that did not arrive the first time) above 2 % over 10 s — a warning, retransmission usually recovers it. “Loss on air”: unrecovered loss above 0.1 % over 10 s — holes in the picture, critical. Default thresholds; your own are in “Alarm settings”.',
    summaryStaleSince: 'no data since {time}',

    sgSpeech: 'Speech',
    sgMusic: 'Music',
    sgHot: 'Overload',
    sgSilence: 'Silence',
    sgDead: 'Data lost',
    sgCriticalUnacked: 'Critical, unacknowledged',
    sgWarningUnacked: 'Warning, unacknowledged',
    sgOnAir: 'On air',
    sgRunning: 'Running',
    sgHlsUrl: 'HLS URL to test the player',
    sgTable: 'Table',
    sgChannel: 'Channel',
    sgState: 'State',
    sgBitrate: 'Bitrate, Mbit/s',
    sgLoss: 'Loss, %',
    sgRow1: 'UN TV, General Assembly hall',
    sgRow3: 'Moscow, backup',
    sgDegraded: 'Degraded',
    sgNoSignal: 'No signal',
  },
})
